<template>
  <div class="page page-data-management">
    <div class="page-toolbar bg-white shadow-sm p-3">
      <breadcrumb />
      <div class="d-flex justify-content-end ">
        <b-button
          v-if="canChangePermission(table)"
          size="sm"
          variant="outline-secondary"
          :to="{ name: 'dataManagementPermissions', params: { itemId: $route.params.tableId, type: permissionItemTypes.table } }"
        >
          <font-awesome-icon :icon="['fas', 'key']" />
          Permissions
        </b-button>
        <b-button
          v-if="canEdit(table)"
          size="sm"
          variant="outline-primary"
          class="ml-1"
          :to="{ name: 'dataManagementBuilderPowerBiReport.update', params: { tableUuid: $route.params.tableId }, query: { moduleUuid: $route.query.moduleUuid } }"
        >
          <font-awesome-icon :icon="['fas', 'pencil-alt']" />
          Edit Report
        </b-button>
      </div>
    </div>
    <div
      id="pageContent"
      class="page-content d-flex flex-column p-3"
    >
      <content-spinner
        :show="loading"
        text="Please wait..."
      />
      <div
        v-if="!loading"
        class="table-wrapper"
      >
        <iframe
          v-if="powerBiReportEntity"
          :src="powerBiReportEntity.PowerBiReportURL"
          class="table-iframe"
        />
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import ContentSpinner from '../../../../core/components/ContentSpinner';
import Breadcrumb from '../../../../core/components/Breadcrumb';

const { mapState, mapActions } = createNamespacedHelpers('dataManagement');

export default {
  name: 'PowerBiReportTableView',
  components: {
    ContentSpinner,
    Breadcrumb,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapState({
      powerBiReportEntity: state => state.powerBiReportEntity,
      table: state => state.tableData.data,
      tableFolder: state => state.folderData.data,
      tableModule: state => state.moduleData.data,
      permissionTypes: state => state.permissionTypes,
      permissionItemTypes: state => state.permissionItemTypes,
    }),
  },
  methods: {
    ...mapActions([
      'getModuleData',
      'getFolderData',
      'getTableData',
      'getPowerBiReportEntity',
    ]),
    async getData() {
      await this.getTableData(this.$route.params.tableId);
      await this.getModuleData(this.table.moduleGuid);
      await this.getFolderData(this.table.folderGuid);
      const { success, body } = await this.getPowerBiReportEntity(this.$route.params.tableId);
      if (!success) {
        debugger;
        this.$toasted.error(body.ErrorMessage, {
          duration: TOASTER_DURATION,
        });
      }
    },
    canEdit(table) {
      return [this.permissionTypes.admin, this.permissionTypes.edit].includes(table.currentUserPermissionLevel);
    },
    canChangePermission(table) {
      return table.currentUserPermissionLevel === this.permissionTypes.admin;
    },
  },
  async mounted() {
    this.loading = true;
    await this.getData();
    this.loading = false;
  },
};
</script>

<style lang="scss" scoped>
.table-wrapper {
  height: 100%;
}

.table-iframe {
  width: 100%;
  height: 100%;
  border: unset;
}
</style>